import { assessment_update } from "./assessment_update";
import { assessments } from "./assessments";
import { assign_reviewers } from "./assign_reviewers";
import { businessIntelligence } from "./business-intelligence";
import { compare } from "./compare";
import { corporations } from "./corporations";
import { countries } from "./countries";
import { errors } from "./errors";
import { general } from "./general";
import { notifications } from "./notifications";
import { profile } from "./profile";
import { protocol_questions } from "./protocol_questions";
import { protocol_set } from "./protocol_set";
import { reports } from "./reports";
import { requirements } from "./requirements";
import { sites } from "./sites";
import { standards } from "./standards";
import { users } from "./users";

export const ptBrTranslations = {
  assessment_update,
  assessments,
  assign_reviewers,
  businessIntelligence,
  compare,
  corporations,
  errors,
  general,
  notifications,
  profile,
  protocol_questions,
  protocol_set,
  reports,
  requirements,
  sites,
  standards,
  users,
  countries,
} as const;

export type ptBrAppTranslations = typeof ptBrTranslations;
